import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "./Radio";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const labelStyles = {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "288px",
        height: "48px",
        marginTop: "4px",
        marginBottom: "4px",
        marginLeft: "16px",

        [theme.breakpoints.up(360)]: {
            width: "330px",
        },
        [theme.breakpoints.up(430)]: {
            width: "400px",
        },
    },
    label: labelStyles,
}));
const useVerticalStyles = makeStyles((theme) => ({
    root: {
        flexDirection: "column-reverse",
        width: "125px",
        height: "130px",
        margin: "5.5px",

        [theme.breakpoints.down(380)]: {
            width: "95px",
            margin: "3px",
        },
        [theme.breakpoints.between(381, 549)]: {
            width: "110px",
        },
    },
    label: {
        ...labelStyles,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "10px",
    },
    labelPlacementTop: {
        justifyContent: "center",
        alignText: "center",
    },
}));
const useCardStyles = makeStyles((theme) => ({
    root: {
        flexDirection: "column",
        width: "195px",
        height: "fit-content",
        margin: "5.5px",
        borderRadius: "8px",

        [theme.breakpoints.down(370)]: {
            width: "138px",
            margin: "3px",
        },
        [theme.breakpoints.between(371, 430)]: {
            width: "170px",
            margin: "4px",
        },
    },
    label: {
        ...labelStyles,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    labelPlacementTop: {
        justifyContent: "center",
        alignText: "center",
    },
}));

const RadioButton = (props) => {
    const styles = useStyles();
    const verticalStyles = useVerticalStyles();
    const cardStyles = useCardStyles();
    const theme = useTheme();
    const checkedStyles = (props.isChecked)
        ? { boxShadow: `0px 0px 0px 2px ${theme.palette.primary.main}` }
        : {};

    const getVariantProps = () => {
        if (props.vertical)
            return {
                classes: verticalStyles,
                labelPlacement: "top",
            };
        if (props.card)
            return {
                classes: cardStyles,
                labelPlacement: "bottom",
            };
        return {
            classes: styles,
            labelPlacement: "end",
        };
    };
    const variantProps = getVariantProps();

    return (
        <FormControlLabel
            {...variantProps}
            style={checkedStyles}
            value={props.value}
            label={props.label}
            onChange={props.onChange}
            checked={props.isChecked}
            disabled={props.isDisabled}
            control={
                <Radio
                    isChecked={props.isChecked}
                    value={props.value}
                    {...(props.card) && { card: true }}
                />
            }
        />
    );
};

export default RadioButton;